import { FacilityOverlay } from '#app/routes/mocra+/_form+/components/facilities/overlay.tsx'
import { type FacilityDraft } from '#app/routes/mocra+/_form+/components/facilities/types.ts'

type Props = {
	readonly open: boolean
	readonly onOpenChange: (open: boolean) => void
	readonly onSubmit: (draft: FacilityDraft) => void
	readonly initialValue: FacilityDraft
	readonly onClosed?: () => void
}

export function FacilityEditOverlay({
	open,
	onOpenChange,
	onSubmit,
	initialValue,
	onClosed,
}: Props) {
	return (
		<FacilityOverlay
			mode="edit"
			open={open}
			onOpenChange={onOpenChange}
			onSubmit={onSubmit}
			initialValue={initialValue}
			onClosed={onClosed}
		/>
	)
}
